<template>
    <div class="verifyIdCard flex-column">
        <van-form validate-first @submit="handleVerify">
            <div style="background-color: #fff">
                <p class="verifyIdCard-title">请上传有效的二代身份证信息</p>
                <van-field name="fronImage">
                    <template #input>
                        <div class="verifyIdCard-image-wrap">
                            <van-uploader :disabled="isCertification != 1" :before-read="beforeRead" :after-read="afterReadFront" name="file">
                                <template #default>
                                    <div v-if="loading1" class="loadingss">
                                        <van-loading color="#fff" text-color="#fff" vertical>图片上传中</van-loading>
                                    </div>
                                    <img v-if="!loading1 && userInfo.frontPicUrl" :src="userInfo.frontPicUrl" alt="" />
                                    <img v-else-if="!loading1 && !userInfo.frontPicUrl" :src="fronImage" alt="" />
                                </template>
                            </van-uploader>
                        </div>
                    </template>
                </van-field>
                <p class="verifyIdCard-desc">
                    <span v-if="isCertification != 0">人像页</span>
                    <span v-else-if="isCertification == 0">扫描上传人像页</span>
                </p>
                <van-field name="backImage">
                    <template #input>
                        <div class="verifyIdCard-image-wrap">
                            <van-uploader :disabled="isCertification != 1" :before-read="beforeRead" :after-read="afterReadBack" name="file">
                                <template #default>
                                    <div v-if="loading2" class="loadingss">
                                        <van-loading color="#fff" text-color="#fff" vertical>图片上传中</van-loading>
                                    </div>
                                    <img v-if="!loading2 && userInfo.backPicUrl" :src="userInfo.backPicUrl" alt="" />
                                    <img v-else-if="!loading2 && !userInfo.backPicUrl" :src="backImage" alt="" />
                                </template>
                            </van-uploader>
                        </div>
                    </template>
                </van-field>
                <p class="verifyIdCard-desc">
                    <span v-if="isCertification != 0">国徽页</span>
                    <span v-else-if="isCertification == 0">扫描上传国徽页</span>
                </p>
            </div>

            <!-- 未认证 -->
            <div v-if="isCertification == 1">
                <div class="verifyIdCard-confirm">
                    <van-checkbox checked-color="#009af3" v-model="checked">我已同意<span @click.stop="toArgeement" style="color: #009af3; text-decoration: underline">《认证协议》</span></van-checkbox>
                    <div class="btn">
                        <van-button :loading="uploading" class="verifyIdCard-confirm-btn" block>提交认证</van-button>
                    </div>
                </div>
            </div>
        </van-form>

        <loading :show="uploading" text="上传中..." />
    </div>
</template>

<script>
import rules from "@/libs/fieldValidateRules";
import { beforeRead } from "@/libs/tools";
import { uploadImage, submitRealNameCert } from "@/api/api";
import { fileToBase64 } from "@/libs/tools";
import Loading from "@/components/base/loading/loading.vue";

export default {
    name: "verifyIdCard",
    components: {
        Loading,
    },
    data() {
        return {
            userInfo: JSON.parse(localStorage.getItem("userInfo")),
            fronImage: require("@/assets/images/user/idcard-front.png"),
            backImage: require("@/assets/images/user/idcard-back.png"),
            checked: false,
            isCertification: -1, //1:未认证 2:已认证

            loading1: false,
            loading2: false,

            uploading: false,
        };
    },
    mounted() {
        this.userInfo = this.$route.query;

        // this.userInfo = {
        //     backPicUrl: "",
        //     frontPicUrl: "",
        //     isCertification: 1,
        // };

        this.isCertification = this.userInfo.isCertification;
    },
    methods: {
        beforeRead,
        toArgeement() {
            this.$router.push({ name: "verifyProtocol", params: this.userInfo });
        },
        //认证
        handleVerify() {
            if (!this.checked) {
                this.$toast("请先查看认证协议");
            } else {
                // let params = {
                //     backImg: this.userInfo.backPicUrl,
                //     frontImg: this.userInfo.frontPicUrl,
                // };
                if (!this.userInfo.backPicUrl || !this.userInfo.frontPicUrl) {
                    this.$toast("请上传两张图片");
                    return;
                }
                let params = {
                    backImg: this.userInfo.backPicUrl.split(",")[1],
                    frontImg: this.userInfo.frontPicUrl.split(",")[1],
                };
                this.uploading = true;

                submitRealNameCert(params)
                    .then((res) => {
                        this.$toast("已通过认证");
                        this.$store.dispatch("getUserInfo"); //更新全局的userInfo
                        this.$router.replace("/mine/userinfo");
                    })
                    .finally(() => {
                        this.uploading = false;
                    });
            }
        },
        //上传第一张照片
        afterReadFront(file) {
            this.loading1 = true;
            console.log(file.file);
            fileToBase64(file.file).then((res) => {
                this.loading1 = false;
                this.userInfo.frontPicUrl = res;
            });

            // uploadImage(file.file).then((res) => {
            //     this.loading1 = false;
            //     this.userInfo.frontPicUrl = res.data.imgUrl;
            // });
        },
        //上传第二张照片
        afterReadBack(file) {
            this.loading2 = true;

            fileToBase64(file.file).then((res) => {
                this.loading2 = false;
                this.userInfo.backPicUrl = res;
            });
            // uploadImage(file.file).then((res) => {
            //     this.loading2 = false;
            //     this.userInfo.backPicUrl = res.data.imgUrl;
            // });
        },

        //身份证
        validatorIDCard(val) {
            console.log(rules.chinaId.regex.test(val));
            return rules.chinaId.regex.test(val);
        },
    },
};
</script>

<style lang="less" scoped>
.loadingss {
    background-color: #4a4a4b;
    width: 455px;
    height: 288px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.verifyIdCard {
    min-height: 100vh;

    .verifyIdCard-title {
        font-size: 32px;
        color: #222222;
        padding: 46px 33px 20px;
        background-color: #fff;
    }

    .verifyIdCard-image-wrap {
        width: 455px;
        height: 300px;
        margin: 0px auto;
        border: 1px dotted #999999;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .verifyIdCard-desc {
        font-size: 28px;
        color: #666666;
        margin: 15px auto 0;
        padding-bottom: 30px;
        text-align: center;
    }

    .verifyIdCard-input-wrap {
        margin-top: 16px;
    }

    .verifyIdCard-confirm {
        padding: 24px;
        margin-top: auto;
        .btn {
            position: absolute;
            bottom: 0;
            left: 0;
            height: 100px;
            width: 100%;
            background-color: #fff;

            display: flex;
            justify-content: center;
            align-items: center;
        }
        .verifyIdCard-confirm-btn {
            width: 702px;
            height: 70px;
            font-size: 32px;
            // margin-top: 32px;
            border-radius: 16px;

            color: #fff;
            background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
        }

        .verifyIdCard-confirm-fail {
            font-size: 24px;
            color: #f72d2d;
            text-align: center;
            margin-top: 15px;
        }
    }
}
</style>
